export default __webpack_public_path__ + "static/media/transaction.df6e1678.png";